import Analytics from '@withlocals/withlocals-analytics';
import { Translator } from 'Translator';
import LocalizedLink from 'components/LocalizedLink';
import RoundedButton from 'components/RoundedButton';
import locationTextPretty from 'modules/homescreen/helpers/locationTextPretty';
import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { generatePathnameWithLangCode } from 'utils/RouteHelper';
import { translateCity, translateCountry } from 'utils/TranslationHelper';
import slugify from 'utils/slugify';

import { WlWindow } from '../../../../../typings/globals/cordova';

declare const window: WlWindow;

const CSS = require('./ViewAllExperiencesButton.less');

type ViewAllExperiencesButtonProps = {
  city?: string;
  country?: string;
};

function ViewAllExperiencesButton({
  city,
  country,
  history,
}: ViewAllExperiencesButtonProps & RouteComponentProps) {
  let textForLink: string;
  let to: string;
  if (city || country) {
    textForLink = Translator.translate(
      'SearchPage.SearchResults.removeFilterNoticeTextLocation',
      {
        location: city
          ? translateCity(city, true)
          : translateCountry(country, true),
      },
      true,
      'View all experiences in {location}',
    );
    if (city && country) {
      to = `/s/${slugify(country, false)}/${slugify(city, false)}/`;
    } else {
      to = `/s/${slugify(country, false)}/`;
    }
  } else {
    textForLink = Translator.translate(
      'SearchPage.SearchResults.removeFilterNoticeTextAll',
      {},
      true,
      'View all experiences',
    );
    to = '/s/';
  }

  const onSubmit = () => {
    const locationText = locationTextPretty(city, country);
    Analytics.track(
      window.currentPageCategory,
      'See all experiences click',
      locationText,
    );
    history.push(
      generatePathnameWithLangCode(to, Translator.getLanguageCode()),
    );
  };

  return (
    <div className={CSS.Notice}>
      <div className={CSS.ViewAllExperiences}>
        <RoundedButton
          onClick={onSubmit}
          className={CSS.ViewAllExperiencesButton}
        >
          <LocalizedLink to={to} className={CSS.SubmitText}>
            {textForLink}
          </LocalizedLink>
        </RoundedButton>
      </div>
    </div>
  );
}

export default withRouter(ViewAllExperiencesButton);
